export default __webpack_public_path__ + "static/media/no-results-found.624b734e.png";